import type { IGetInvitationListRequest, IInvitationListResponse, IRedeemRequest, IRewardStatusResponse } from '../types';

export const PlgApi = Symbol('PlgApi');

export interface PlgApi {
    /**
     * 获取邀请记录
     * @returns 邀请记录列表
     */
    getInvitationList(params: IGetInvitationListRequest): Promise<IInvitationListResponse>;

    /**
     * 兑换奖励
     * @param params 兑换参数，包含兑换类型
     * @returns 兑换结果
     */
    redeemReward(params: IRedeemRequest): Promise<boolean>;

    /**
     * 获取奖励状态
     * @returns 奖励状态
     */
    getRewardStatus(): Promise<IRewardStatusResponse>;
}
